import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './store/auth-context';
import { ToastContainer, toast } from 'react-toastify';
import ToastContext from './store/toast-context';

import './styles/app.scss';
import 'react-toastify/dist/ReactToastify.min.css';
import config from './config';

const toastValues = {
  dark: toast.dark,
  default: toast,
  error: toast.error,
  info: toast.info,
  success: toast.success,
  warning: toast.warning,
  handleError: (e) => {
    let errorMessage = '';
    if (e.response) {
      errorMessage = e.response?.data?.message ?? e.response?.data ?? 'Something went wrong';
    } else {
      errorMessage = e.message ?? 'Could not connect to server';
    }
    toast.error(errorMessage);
  },
};

ReactDOM.render(
  <StrictMode>
    <ToastContext.Provider value={toastValues}>
      <ToastContainer containerId="toast-container" />
      <BrowserRouter basename={config.basePath}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ToastContext.Provider>
  </StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
